var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { map } from 'lodash';
import { AtIcon, EmailFilledIcon, EmailIcon, ExploreIcon, ExternalLinkIcon, FacebookFilledIcon, FacebookIcon, FlickrFilledIcon, FlickrIcon, LinkedinFilledIcon, LinkedinIcon, PaperclipIcon, PartnershipsTrendsIcon, ThreadsFilledIcon, ThreadsIcon, ThumbsUpIcon, ThumbsUpFilledIcon, TickIcon, TickRoundedIcon, SubMenuIcon, FundingTrendsIcon, PolicyTrendsIcon, NetworkMapIcon, GridIcon, DonutNavigatorIcon, ConnectionsNavigatorIcon, ShareIcon, CrossIcon, CrossRoundedIcon, ArrowUpIcon, ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, SearchIcon, QuestionIcon, HeartIcon, HeartFilledIcon, InfoIcon, NodesIcon, AiUpperCaseIcon, AiCIcon, AiStarIcon, LoginIcon, LogoutIcon, DownloadIcon, PlusIcon, PlusRoundedIcon, BinIcon, ChevronLeftIcon, ChevronLeftThinIcon, ChevronRightIcon, ChevronRightThinIcon, ChevronDownIcon, ChevronDownThinIcon, ChevronUpIcon, ChevronUpThinIcon, ConversationsStraightIcon, FullscreenExitIcon, FullscreenEnterIcon, ShapeIcon, ChangeIcon, AwareIcon, FutureIcon, JoinIcon, FollowIcon, AiLowerCaseIcon, RadarIcon, ReplyIcon, EnvironmentalIcon, ArrowsCrossingIcon, PenIcon, PencilUnderlineIcon, PictureFileIcon, SendIcon, ImageIcon, ImagePlusIcon, PersonSpeakingIcon, FocusIcon, DownloadFlatLineIcon, DottedChevronLeftIcon, DottedChevronRightIcon, DottedChevronUpIcon, DottedChevronDownIcon, DottedChevronLeftHeavyIcon, DottedChevronRightHeavyIcon, DottedChevronUpHeavyIcon, DottedChevronDownHeavyIcon, DocumentSmallIcon, TwitterIcon, TwitterFilledIcon, XIcon, XFilledIcon, InfoFilledIcon, DownloadAltIcon, TagDotIcon, TagIcon, ChatTextIcon, ChatTextDotIcon, CalendarIcon, TikTokIcon, YouTubeIcon, ConnectionsIcon, WorldMapIcon, CopyIcon, ProjectIcon, HomeIcon } from './';
import { BannerIcon, BenefitIcon, BenefitTypeIcon, BlockIcon, BusinessModelIcon, ChallengeIcon, ChapterIcon, ChapterRoleIcon, CitationIcon, ClusterIcon, CommodityIcon, CourseIcon, DataSetIcon, DocumentIcon, DocumentTypeIcon, EconomyIcon, EventIcon, FeedEntryIcon, FeedIcon, FileAssetIcon, FileTypeIcon, FolderIcon, HorizonIcon, ImpactResultIcon, ImpactResultTypeIcon, ImpactStoryIcon, IndicatorIcon, IndicatorValueIcon, IndustryIcon, InfluencingFactorIcon, InnovationIcon, KeyIssueIcon, LayoutIcon, LessonIcon, LinkIcon, LinkTypeIcon, ListIcon, ListTypeIcon, LocationIcon, MaturityStageIcon, MenuIcon, OfferingTypeIcon, OrganisationIcon, OrganisationTypeIcon, PageIcon, PersonIcon, PillarIcon, PledgeIcon, PositionIcon, ProductIcon, ProjectTypeIcon, QuoteIcon, RestorationMetricIcon, RestorationProjectIcon, SdgIcon, SessionIcon, SiteIcon, SkillIcon, SliceIcon, StateIcon, SubTopicIcon, TargetIcon, TeamIcon, TechnologyIcon, TopicIcon, TrendIcon, UnitIcon, UserPermissionIcon, VenueIcon, VideoIcon } from '../entities';
import { BookmarkIcon } from './bookmark-icon';
import { CropIcon } from './crop-icon';
import { GlobeIcon } from './globe-icon';
import { InstagramFilledIcon } from './instagram-filled-icon';
import { InstagramIcon } from './instagram-icon';
import { TikTokFilledIcon } from './tik-tok-filled-icon';
import { YouTubeFilledIcon } from './you-tube-filled-icon';
import { ThumbsUpPlusIcon } from './thumbs-up-plus-icon';
var cls = classNames('icon-sheet');
export var IconSheetDefaultProps = {
  size: 48
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var IconGroupStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row; \n    gap: 12px;\n    align-items: center;\n  "], ["\n    display: flex;\n    flex-direction: row; \n    gap: 12px;\n    align-items: center;\n  "])))
});
var IconsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: #EEE;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: ", ";\n  "], ["\n    background: #EEE;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: ", ";\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icons: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IconsStyles),
  IconGroup: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconGroupStyles)
};
export var IconSheet = function (props) {
  var className = props.className,
    children = props.children,
    size = props.size;
  var iconsToShow = [{
    Component: AiCIcon,
    label: "AI C"
  }, {
    Component: AiLowerCaseIcon,
    label: "AI Lower-case"
  }, {
    Component: AiStarIcon,
    label: "AI Star"
  }, {
    Component: AiUpperCaseIcon,
    label: "AI Upper-case"
  }, {
    Component: ArrowsCrossingIcon,
    label: "Arrows Crossing"
  }, {
    Component: ArrowUpIcon,
    label: "Arrow Up"
  }, {
    Component: ArrowDownIcon,
    label: "Arrow Down"
  }, {
    Component: ArrowLeftIcon,
    label: "Arrow Left"
  }, {
    Component: ArrowRightIcon,
    label: "Arrow Right"
  }, {
    Component: AtIcon,
    label: "At"
  }, {
    Component: AwareIcon,
    label: "Aware"
  }, {
    Component: BannerIcon,
    label: "Banner"
  }, {
    Component: BenefitIcon,
    label: "Benefit"
  }, {
    Component: BenefitTypeIcon,
    label: "Benefit Type"
  }, {
    Component: BinIcon,
    label: "Bin"
  }, {
    Component: BlockIcon,
    label: "Block"
  }, {
    Component: BookmarkIcon,
    label: "Bookmark"
  }, {
    Component: BusinessModelIcon,
    label: "Business Model"
  }, {
    Component: CalendarIcon,
    label: "Calendar"
  }, {
    Component: ChallengeIcon,
    label: "Challenge"
  }, {
    Component: ChangeIcon,
    label: "Change"
  }, {
    Component: ChapterIcon,
    label: "Chapter"
  }, {
    Component: ChapterRoleIcon,
    label: "Chapter Role"
  }, {
    Component: ChatTextIcon,
    label: "Chat Text"
  }, {
    Component: ChatTextDotIcon,
    label: "Chat Text Dot"
  }, {
    Component: ChevronLeftIcon,
    label: "Chevron Left"
  }, {
    Component: ChevronRightIcon,
    label: "Chevron Right"
  }, {
    Component: ChevronLeftThinIcon,
    label: "Chevron Thin Left"
  }, {
    Component: ChevronRightThinIcon,
    label: "Chevron Thin Right"
  }, {
    Component: ChevronDownIcon,
    label: "Chevron Down"
  }, {
    Component: ChevronDownThinIcon,
    label: "Chevron Thin Down"
  }, {
    Component: ChevronUpIcon,
    label: "Chevron Up"
  }, {
    Component: ChevronUpThinIcon,
    label: "Chevron Thin Up"
  }, {
    Component: CitationIcon,
    label: "Citation"
  }, {
    Component: ClusterIcon,
    label: "Cluster"
  }, {
    Component: CommodityIcon,
    label: "Commmodity"
  }, {
    Component: ConnectionsIcon,
    label: "Connections"
  }, {
    Component: ConnectionsNavigatorIcon,
    label: "Connections Navigator"
  }, {
    Component: ConversationsStraightIcon,
    label: "Conversations Straight"
  }, {
    Component: CourseIcon,
    label: "Course"
  }, {
    Component: CopyIcon,
    label: "Copy"
  }, {
    Component: CropIcon,
    label: "Crop"
  }, {
    Component: CrossIcon,
    label: "Cross"
  }, {
    Component: CrossRoundedIcon,
    label: "Cross Rounded"
  }, {
    Component: DataSetIcon,
    label: "Data Set"
  }, {
    Component: DocumentIcon,
    label: "Document"
  }, {
    Component: DocumentTypeIcon,
    label: "Document Type"
  }, {
    Component: DonutNavigatorIcon,
    label: "Donut Navigator"
  }, {
    Component: DottedChevronLeftIcon,
    label: "Dotted Chevron Left"
  }, {
    Component: DottedChevronRightIcon,
    label: "Dotted Chevron Right"
  }, {
    Component: DottedChevronUpIcon,
    label: "Dotted Chevron Up"
  }, {
    Component: DottedChevronDownIcon,
    label: "Dotted Chevron Down"
  }, {
    Component: DocumentSmallIcon,
    label: "Document Small"
  }, {
    Component: DottedChevronLeftHeavyIcon,
    label: "Dotted Chevron Left Heavy"
  }, {
    Component: DottedChevronRightHeavyIcon,
    label: "Dotted Chevron Right Heavy"
  }, {
    Component: DottedChevronUpHeavyIcon,
    label: "Dotted Chevron Up Heavy"
  }, {
    Component: DottedChevronDownHeavyIcon,
    label: "Dotted Chevron Down Heavy"
  }, {
    Component: DownloadIcon,
    label: "Download"
  }, {
    Component: DownloadFlatLineIcon,
    label: "Download Flat Line"
  }, {
    Component: DownloadAltIcon,
    label: "Download Alt"
  }, {
    Component: EconomyIcon,
    label: "Economy"
  }, {
    Component: EmailIcon,
    label: "Email"
  }, {
    Component: EmailFilledIcon,
    label: "Email Filled"
  }, {
    Component: EnvironmentalIcon,
    label: "Environmental"
  }, {
    Component: EventIcon,
    label: "Event"
  }, {
    Component: ExternalLinkIcon,
    label: "External Link"
  }, {
    Component: ExploreIcon,
    label: "Explore"
  }, {
    Component: FacebookIcon,
    label: "Facebook"
  }, {
    Component: FacebookFilledIcon,
    label: "Facebook Filled"
  }, {
    Component: FeedEntryIcon,
    label: "Feed Entry"
  }, {
    Component: FeedIcon,
    label: "Feed"
  }, {
    Component: FileAssetIcon,
    label: "File Asset"
  }, {
    Component: FileTypeIcon,
    label: "File Asset Type"
  }, {
    Component: FlickrIcon,
    label: "Flickr"
  }, {
    Component: FlickrFilledIcon,
    label: "Flickr Filled"
  }, {
    Component: FocusIcon,
    label: "Focus"
  }, {
    Component: FolderIcon,
    label: "Folder"
  }, {
    Component: FollowIcon,
    label: "Follow"
  }, {
    Component: FullscreenExitIcon,
    label: "Fullscreen Exit"
  }, {
    Component: FullscreenEnterIcon,
    label: "Fullscreen Enter"
  }, {
    Component: FundingTrendsIcon,
    label: "Funding Trends"
  }, {
    Component: FutureIcon,
    label: "Future"
  }, {
    Component: GlobeIcon,
    label: "Globe"
  }, {
    Component: GridIcon,
    label: "Grid"
  }, {
    Component: HeartIcon,
    label: "Heart"
  }, {
    Component: HeartFilledIcon,
    label: "Heart Filled"
  }, {
    Component: HomeIcon,
    label: "Home"
  }, {
    Component: HorizonIcon,
    label: "Horizon"
  }, {
    Component: InfoIcon,
    label: "Info"
  }, {
    Component: InfoFilledIcon,
    label: "Info Filled"
  }, {
    Component: ImageIcon,
    label: "Image"
  }, {
    Component: ImagePlusIcon,
    label: "Image Plus"
  }, {
    Component: ImpactResultIcon,
    label: "Impact Result"
  }, {
    Component: ImpactResultTypeIcon,
    label: "Impact Result Type"
  }, {
    Component: ImpactStoryIcon,
    label: "Impact Story"
  }, {
    Component: IndicatorIcon,
    label: "Indicator"
  }, {
    Component: IndicatorValueIcon,
    label: "Indicator Value"
  }, {
    Component: IndustryIcon,
    label: "Industry"
  }, {
    Component: InfluencingFactorIcon,
    label: "Influencing Factor"
  }, {
    Component: InnovationIcon,
    label: "Innovation"
  }, {
    Component: InstagramIcon,
    label: "Instagram"
  }, {
    Component: InstagramFilledIcon,
    label: "Instagram Filled"
  }, {
    Component: JoinIcon,
    label: "Join"
  }, {
    Component: KeyIssueIcon,
    label: "Key Issue"
  }, {
    Component: LayoutIcon,
    label: "Layout"
  }, {
    Component: LessonIcon,
    label: "Lesson"
  }, {
    Component: LinkIcon,
    label: "Link"
  }, {
    Component: LinkTypeIcon,
    label: "Link Type"
  }, {
    Component: LinkedinIcon,
    label: "Linkedin"
  }, {
    Component: LinkedinFilledIcon,
    label: "Linkedin Filled"
  }, {
    Component: ListIcon,
    label: "List"
  }, {
    Component: ListTypeIcon,
    label: "List Type"
  }, {
    Component: LocationIcon,
    label: "Location"
  }, {
    Component: LoginIcon,
    label: "Login"
  }, {
    Component: LogoutIcon,
    label: "Logout"
  }, {
    Component: MaturityStageIcon,
    label: "Maturity Stage"
  }, {
    Component: MenuIcon,
    label: "Menu"
  }, {
    Component: NetworkMapIcon,
    label: "Network Map"
  }, {
    Component: NodesIcon,
    label: "Nodes"
  }, {
    Component: OfferingTypeIcon,
    label: "Offering Type"
  }, {
    Component: OrganisationIcon,
    label: "Organisation"
  }, {
    Component: OrganisationTypeIcon,
    label: "Organisation Type"
  }, {
    Component: PageIcon,
    label: "Page"
  }, {
    Component: PaperclipIcon,
    label: "Paperclip"
  }, {
    Component: PartnershipsTrendsIcon,
    label: "Partnerships Trends"
  }, {
    Component: PersonIcon,
    label: "Person"
  }, {
    Component: PersonSpeakingIcon,
    label: "Person Speaking"
  }, {
    Component: PencilUnderlineIcon,
    label: "Pencil Underline"
  }, {
    Component: PenIcon,
    label: "Pen"
  }, {
    Component: PictureFileIcon,
    label: "Picture File"
  }, {
    Component: PillarIcon,
    label: "Pillar"
  }, {
    Component: PledgeIcon,
    label: "Pledge"
  }, {
    Component: PlusIcon,
    label: "Plus"
  }, {
    Component: PlusRoundedIcon,
    label: "Plus Rounded"
  }, {
    Component: PolicyTrendsIcon,
    label: "Policy Trends"
  }, {
    Component: PositionIcon,
    label: "Position"
  }, {
    Component: ProductIcon,
    label: "Product"
  }, {
    Component: ProjectIcon,
    label: "Project"
  }, {
    Component: ProjectTypeIcon,
    label: "Project Type"
  }, {
    Component: QuestionIcon,
    label: "Question"
  }, {
    Component: QuoteIcon,
    label: "Quote"
  }, {
    Component: RadarIcon,
    label: "Radar"
  }, {
    Component: ReplyIcon,
    label: "Reply"
  }, {
    Component: RestorationMetricIcon,
    label: "Restoration Metric"
  }, {
    Component: RestorationProjectIcon,
    label: "Restoration Project"
  }, {
    Component: SdgIcon,
    label: "SDG"
  }, {
    Component: SearchIcon,
    label: "Search"
  }, {
    Component: SendIcon,
    label: "Send"
  }, {
    Component: SessionIcon,
    label: "Session"
  }, {
    Component: ShapeIcon,
    label: "Shape"
  }, {
    Component: ShareIcon,
    label: "Share"
  }, {
    Component: SiteIcon,
    label: "Site"
  }, {
    Component: SkillIcon,
    label: "Skill"
  }, {
    Component: SliceIcon,
    label: "Slice"
  }, {
    Component: StateIcon,
    label: "State"
  }, {
    Component: SubMenuIcon,
    label: "Sub Menu"
  }, {
    Component: SubTopicIcon,
    label: "Sub Topic"
  }, {
    Component: TagDotIcon,
    label: "Tag Dot"
  }, {
    Component: TagIcon,
    label: "Tag"
  }, {
    Component: TargetIcon,
    label: "Target"
  }, {
    Component: TeamIcon,
    label: "Team"
  }, {
    Component: TechnologyIcon,
    label: "Technology"
  }, {
    Component: ThreadsIcon,
    label: "Threads"
  }, {
    Component: ThreadsFilledIcon,
    label: "Threads Filled"
  }, {
    Component: ThumbsUpIcon,
    label: "Thumbs Up"
  }, {
    Component: ThumbsUpFilledIcon,
    label: "Thumbs Up Filled"
  }, {
    Component: ThumbsUpPlusIcon,
    label: "Thumbs Up Plus"
  }, {
    Component: TickIcon,
    label: "Tick"
  }, {
    Component: TickRoundedIcon,
    label: "Tick Rounded"
  }, {
    Component: TikTokIcon,
    label: "TikTok"
  }, {
    Component: TikTokFilledIcon,
    label: "TikTok Filled"
  }, {
    Component: TopicIcon,
    label: "Topic"
  }, {
    Component: TrendIcon,
    label: "Trend"
  }, {
    Component: TwitterIcon,
    label: "Twitter"
  }, {
    Component: TwitterFilledIcon,
    label: "Twitter Filled"
  }, {
    Component: UnitIcon,
    label: "Unit"
  }, {
    Component: UserPermissionIcon,
    label: "User Permission"
  }, {
    Component: VenueIcon,
    label: "Venue"
  }, {
    Component: VideoIcon,
    label: "Video"
  }, {
    Component: WorldMapIcon,
    label: "World Map"
  }, {
    Component: XIcon,
    label: "X"
  }, {
    Component: XFilledIcon,
    label: "X Filled"
  }, {
    Component: YouTubeIcon,
    label: "YouTube"
  }, {
    Component: YouTubeFilledIcon,
    label: "YouTube Filled"
  }];
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Icons, null, map(iconsToShow, function (_a, index) {
    var Component = _a.Component,
      label = _a.label;
    return React.createElement(My.IconGroup, null, React.createElement(Component, {
      onClick: function () {
        alert("You clicked ".concat(label));
      },
      size: size,
      colors: {
        hover: {
          fill: 'primary'
        }
      },
      key: index
    }), React.createElement(Component, {
      size: size,
      key: index,
      variant: "glyph"
    }), React.createElement(Component, {
      onClick: function () {
        alert("You clicked ".concat(label));
      },
      size: size,
      colors: {
        fill: '#FFFFFF',
        background: '#FCB10F',
        hover: {
          fill: '#000000'
        }
      },
      key: index
    }), label);
  })));
};
IconSheet.defaultProps = IconSheetDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;